import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { useContentResults } from 'components/Dashboard/ContentResultsContext';

const useContactsFunctionForStakeholders = () => {
  const { contentResults, setContentResults } = useContentResults();
  const { Stakeholders } = contentResults;

  const { generalApiCall } = useGeneralApiCall();

  const verifyIfContactIsAdded = async ({ contactId }) => {
    const pathname = '/api/crm-contact/query';
    const method = 'post';
    const requestProperties = {
      filters: [{ field: 'contactId', value: `${contactId}`, operator: 'str_eq' }],
      pageSize: '10',
      query: '',
    };
    const results = await generalApiCall({ pathname, method, requestProperties, needsAuthentication: true });
    return results?.hits;
  };

  const addOrDeleteContact = async ({ contactId, e, action = 'add', callback = () => {} }) => {
    let el;
    if (e) {
      el = e.target;
      el.disabled = true;
    }
    const pathname = `/api/crm-contact/${action === 'delete' ? 'delete' : 'add-stakeholders'}`;
    const method = 'post';
    let requestProperties;
    if (action === 'add') {
      requestProperties = {
        contactIds: [contactId],
        tags: null,
      };
    } else {
      requestProperties = {
        ids: [contactId],
      };
    }
    const results = await generalApiCall({
      pathname,
      method,
      requestProperties,
      needsAuthentication: true,
      returnError: true,
    });
    if (results !== undefined && !results.status) {
      let resultsForState = {
        ...contentResults,
        Stakeholders: {
          ...Stakeholders,
          contact: {
            ...Stakeholders?.contact,
            contactInformation: action === 'delete' ? [] : results,
          },
        },
      };

      setContentResults(resultsForState);
    } else {
      let message = `An error ocurred.`;
      if (action === 'add') {
        if (results?.status === 403) {
          callback();
        } else {
          createNotification('danger', message);
        }
      } else {
        createNotification('danger', message);
      }
    }
    if (el) {
      el.disabled = false;
    }
  };

  return { verifyIfContactIsAdded, addOrDeleteContact };
};

export default useContactsFunctionForStakeholders;
